function buildCacheKey(...args: unknown[]) {
  return args;
}

export default buildCacheKey;
